import { render, staticRenderFns } from "./MLSPoweredListings.vue?vue&type=template&id=a5970826"
import script from "./MLSPoweredListings.vue?vue&type=script&lang=js"
export * from "./MLSPoweredListings.vue?vue&type=script&lang=js"
import style0 from "./MLSPoweredListings.vue?vue&type=style&index=0&id=a5970826&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports